

// const BASE_URL = 'http://192.168.0.40:5001/api/v1/'; // local
// export const IMAGE_BASE_URL = 'http://192.168.0.40:5001/api/images/';


const BASE_URL = 'https://api.yardsalegogo.com/api/v1/'; // live
export const IMAGE_BASE_URL = 'https://api.yardsalegogo.com/api/images/';

export const PLACES_API_KEY = `AIzaSyDFhipDeFA6Yz_bSOv1CniTLuKf3rr2aNM`;

const Apis = {
    
    //AUTH
    login: `${BASE_URL}auth/adminLogin`,
    dashbaord: (queryParams) => `${BASE_URL}admin/dashboard?${queryParams}`,
    user_details : (queryParams) => `${BASE_URL}admin/dashboard/userDetails?${queryParams}`,

    // Yardsales
    getYardSales: (queryParams) => `${BASE_URL}admin/yardSale?${queryParams}`,
    update_yardsale: (id) => `${BASE_URL}yardSale/${id}`,

    //Pages
    terms: `${BASE_URL}admin/setting/termsAndCondition`,
    privacy: `${BASE_URL}admin/setting/privacyPolicy`,
    about: `${BASE_URL}admin/setting/aboutUs`,
    get_queries: (queryParams) => `${BASE_URL}admin/setting/support?${queryParams}`,
    faqs: (queryParams) =>  `${BASE_URL}admin/setting/faq?${queryParams}`,
    discount_code: (queryParams) => `${BASE_URL}admin/discountCode?${queryParams}`,
    ads_pricing: `${BASE_URL}admin/ads`,
    reset_password:  `${BASE_URL}auth/admin/resetPassword`,
    get_web_queries: (queryParams) => `${BASE_URL}admin/setting/webSupport?${queryParams}`,
    del_user:  (queryParams) =>  `${BASE_URL}admin/dashboard/user?${queryParams}`,


    //Payments
    get_payments: (queryParams) => `${BASE_URL}admin/payment?${queryParams}`,
}

export default Apis;